import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DateRangeFilter = ({ onFilterChange }) => {
  const [selectedRange, setSelectedRange] = useState('30days');

  const ranges = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '90days', label: 'Last 90 Days' },
    { value: 'year', label: 'This Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const handleRangeChange = (range) => {
    setSelectedRange(range);
    if (onFilterChange) {
      onFilterChange(range);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-2">
        <Icon name="Calendar" size={20} color="var(--color-muted-foreground)" />
        <span className="text-sm font-medium text-foreground">Date Range:</span>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {ranges?.map((range) => (
          <button
            key={range?.value}
            onClick={() => handleRangeChange(range?.value)}
            className={`
              px-4 py-2 rounded-lg text-sm font-medium transition-all duration-250
              ${selectedRange === range?.value 
                ? 'bg-primary text-primary-foreground shadow-sm' 
                : 'bg-muted text-foreground hover:bg-muted/80'
              }
            `}
          >
            {range?.label}
          </button>
        ))}
      </div>
      <Button variant="outline" iconName="Download" iconPosition="left" className="ml-auto">
        Export Report
      </Button>
    </div>
  );
};

export default DateRangeFilter;